<template>
    <div>
        <div :id="screen.id" class="image-preview" :style="backgroundStyle">
            <input class="image-upload" type="file" ref="uploader" @change.prevent="onChange" />
        </div>
        <div class="image-options">
            <a href="#" v-if="filename" @click.prevent="remove">Remove Image</a>
            <a href="#" v-else class="image-pick-link" @click.prevent="choose" :data-image-uploader="`image-upload-${screen.id}`">Choose File</a>
        </div>
    </div>
</template>

<script>
import { settings } from '../framework/settings';
import { api } from '../framework/api';
import toastr from 'toastr'

export default {
    props: { screen: { type: Object, required: true }, reviewId: { type: String, required: true } },
    data() {
        return {
            input: null,
            noImage: `${settings.siteUrl}/no_image_available_1_14.gif`,
            filename: this.screen.filename,
            backgroundStyle: {
                backgroundSize: 'cover',
                backgroundPosition: 'center center'
            }
        }
    },
    created() {
        this.setBackground(this.screen.src);
    },
    computed: {
        previewBox() {
            return `#${this.screen.id}`;
        }
    },
    methods: {
        setBackground(src) {
            this.$set(this.backgroundStyle, 'backgroundImage', `url("${src}")`);
        },
        async onChange() {
            let files = this.$refs.uploader.files;
            if(files.length) {
                let file = files[0];
                let reader = new FileReader();
                reader.addEventListener('load', async (event) => {
                    let loadedFile = event.target;
                    if(file.type.match('image')) {
                        try {
                            await api.post(`reviews/${this.reviewId}/screenshot`, { filename: file.name, type: file.type, file: loadedFile.result });
                            this.setBackground(loadedFile.result);
                            this.filename = file.name;
                            toastr.success('Screenshot updated');
                        }
                        catch(err) {
                            toastr.error('Unable to save screenshot');
                        }
                    }
                });
                reader.readAsDataURL(file);
            }
        },
        async remove() {
            await api.delete(`reviews/${this.reviewId}/screenshot/${this.filename}`);
            this.filename = null;
            this.setBackground(this.noImage);
        },
        choose() {
            this.$refs.uploader.click();
        }
    },
}
</script>

<style scoped>
    .image-options {
        margin-left: 20px;
    }

    .image-preview {
        width: 400px;
        height: 300px;
        position: relative;
        overflow: hidden;
        background-color: #ffffff;
        color: #ecf0f1;
        margin-left: 20px;
    }
    .image-preview input {
        line-height: 0px;
        font-size: 0px;
        position: absolute;
        opacity: 0;
        z-index: 10;
    }

    .image-preview i {
        margin-left: 15px;
    }

    .image-preview label {
        position: absolute;
        z-index: 5;
        opacity: 0.8;
        cursor: pointer;
        background-color: #bdc3c7;
        width: 200px;
        height: 50px;
        font-size: 20px;
        line-height: 50px;
        text-transform: uppercase;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/ScreenshotEditor.vue